import React from "react";
import Card from "../../Cards";
import axios from "axios";
import { seasonEpisodeDisplay } from "../../../helpers";

class Season extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      season: {}
    };
  }

  fetch = _ => {
    let tv_show_id = this.props.match.params.id;
    let season_id = this.props.match.params.season;

    if (season_id && this.state.id !== season_id) {
      axios.get(`tv/${tv_show_id}/season/${season_id}`).then(response => {
        this.setState({ id: season_id, season: response.data });
      });
    }
  };

  componentDidMount() {
    this.fetch();
  }

  render() {
    return (
      <div className="flex flex-wrap -mx-2">
        {this.state.season.episodes &&
          this.state.season.episodes.map(episode => {
            return (
              <Card
                className="w-full lg:w-1/2 xl:w-1/3 px-2 mb-3 text-center"
                divClassName="justify-center"
                link={`${this.props.match.url}/episode/${
                  episode.episode_number
                }`}
                description={episode.overview}
                title={episode.name}
                subtitle={seasonEpisodeDisplay(episode)}
                key={episode.id}
              />
            );
          })}
      </div>
    );
  }
}

export default Season;



// WEBPACK FOOTER //
// ./src/components/Media/TvShow/Season.js